import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useUser } from '../context/UserContext';
import './DailyUtilisationReport.css';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

const DailyUtilisationReport = () => {
  const { userData, selectedCenter } = useUser();
  const [academyOptions, setAcademyOptions] = useState([]);
  const [selectedAcademy, setSelectedAcademy] = useState(null);
  const [academiesLoaded, setAcademiesLoaded] = useState(false);
  const token = localStorage.getItem('auth-token');
  const today = new Date().toISOString().split('T')[0];
  const [fromDateFilter, setFromDateFilter] = useState(today);
  const [toDateFilter, setToDateFilter] = useState(today);
  const [fromTimeFilter, setFromTimeFilter] = useState(null);
  const [toTimeFilter, setToTimeFilter] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL_FEEDBACK_FETCH, {
      headers: { 'Authorization': `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(json => {
        if (!json.success) throw new Error(json.message || 'Failed to load academies');
        const opts = Object.entries(json.data.academyNameMap).map(([id, name]) => ({
          value: Number(id),
          label: name,
        }));
        const filtered = userData?.userType === 'ACADEMY'
          ? opts.filter(o => userData.academyIds.includes(o.value))
          : opts;

        setAcademyOptions(filtered);
        if (selectedCenter) {
          const def = filtered.find(o => o.value === Number(selectedCenter));
          if (def) setSelectedAcademy(def);
        }
        setAcademiesLoaded(true);
      })
      .catch(err => {
        console.error('Error loading academies:', err);
        setAcademiesLoaded(true);
      });
  }, [userData, selectedCenter]);
  const fetchUtilizationData = async () => {
    if (!academiesLoaded) {
      console.error('⚠️ Skipping fetch: academies not loaded yet');
      return;
    }
    if (!fromDateFilter || !toDateFilter) {
      console.error('⚠️ Skipping fetch: dates not set');
      return;
    }

    setError(null);
    setLoading(true);
    let acadArray = [];
    if (userData.userType === 'ACADEMY') {
      acadArray = selectedAcademy
        ? [selectedAcademy.value]
        : (userData.academyIds || []);
    } else if (selectedAcademy) {
      acadArray = [selectedAcademy.value];
    }

    const parts = [

      ...(acadArray.length ? [`academyId=${acadArray.join(',')}`] : []),
      `startDate=${fromDateFilter}`,
      `endDate=${toDateFilter}`,

      ...(fromTimeFilter?.value ? [`startTime=${fromTimeFilter.value}:00`] : []),
      ...(toTimeFilter?.value ? [`endTime=${toTimeFilter.value}:00`] : []),
    ];

    const url = `${process.env.REACT_APP_API_URL_GET_UTILISATION}?${parts.join('&')}`;
  

    try {
      const res = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });


      const json = await res.json();


      if (!json.success) {
        throw new Error(json.message || 'API returned success: false');
      }
      const raw = json.data.sportSourceWiseUtilization;
      const map = json.data.sportNameMap || {};
      const formatted = Object.entries(raw)
        .map(([sportId, d]) => {
          const coaching = d.coaching || 0;
          const maintenance = d.maintenance || 0;
          const membership = d['playing membership'] || 0;
          const playOBooking = d.playo || 0;
          const bulkBooking = d['bulk booking'] || 0;
          const walkIn = d.walk_in || 0;
          const total = coaching + maintenance + membership + playOBooking + bulkBooking + walkIn;
          return {
            sportId,
            sport: map[sportId] || 'Unknown',
            coaching,
            maintenance,
            membership,
            playOBooking,
            bulkBooking,
            walkIn,
            total,
          };
        })
        .filter(r => r.sport);


      setData(formatted);

    } catch (err) {

      setError(err.message || 'Something went wrong');
    } finally {

      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUtilizationData();
  }, [
    academiesLoaded,
    selectedAcademy,
    fromDateFilter,
    toDateFilter,
    fromTimeFilter,
    toTimeFilter,
    userData,
  ]);


  const totals = data.reduce(
    (acc, row) => {
      acc.coaching += row.coaching;
      acc.maintenance += row.maintenance;
      acc.membership += row.membership;
      acc.playOBooking += row.playOBooking;
      acc.walkIn += row.walkIn;
      acc.bulkBooking += row.bulkBooking;
      acc.total += row.total;
      return acc;
    },
    {
      coaching: 0,
      maintenance: 0,
      membership: 0,
      playOBooking: 0,
      walkIn: 0,
      bulkBooking: 0,
      total: 0,
    }
  );


  const handleFromDateChange = (e) => setFromDateFilter(e.target.value);
  const handleToDateChange = (e) => setToDateFilter(e.target.value);
  const handleFromTimeChange = (e) => setFromTimeFilter(e.target.value);
  const handleToTimeChange = (e) => setToTimeFilter(e.target.value);
  const generateTimeOptions = (openTime, closeTime) => {
    const times = [];
    let startTime = new Date(`1970-01-01T${openTime}:00`);
    const endTime = new Date(`1970-01-01T${closeTime}:00`);

    while (startTime <= endTime) {
      const formattedTime = startTime.toTimeString().slice(0, 5);
      times.push({ value: formattedTime, label: formattedTime });
      startTime.setMinutes(startTime.getMinutes() + 30);
    }
    return times;
  };



  return (
    <div className="enrollment-container" style={{ overflow: 'visible' }}>
      <div className="sales-filters-login">
        <div className="floating-select">
          <Select
            name="academy" options={academyOptions}
            className={`sales-filter-court-booking ${selectedAcademy ? "has-value" : ""}`}
            value={selectedAcademy}
            onChange={setSelectedAcademy}
            placeholder="Select Academy"
            isClearable
            menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
            styles={{
              menuPortal: base => ({ ...base, zIndex: 9999 }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {selectedAcademy && <label htmlFor="academy">Academy</label>}
        </div>


        {/* Sport Filter
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${sportFilter ? "has-value" : ""}`}
            classNamePrefix="react-select"
            id="sportFilter"
            options={sportOptions}
            value={sportFilter}
            onChange={setSportFilter}
            placeholder="Sport"
            isClearable
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {sportFilter && <label htmlFor="sportFilter">Sport</label>}
        </div> */}


        {/* From Time Filter */}
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${fromTimeFilter ? "has-value" : ""}`}
            classNamePrefix="react-select"
            name="fromTimeFilter"
            value={fromTimeFilter}
            onChange={setFromTimeFilter}
            options={generateTimeOptions("00:00", "23:30")}
            placeholder="From Time"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {fromTimeFilter && <label htmlFor="fromTimeFilter">From Time</label>}
        </div>

        {/* To Time Filter */}
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${toTimeFilter ? "has-value" : ""}`}
            classNamePrefix="react-select"
            name="toTimeFilter"
            value={toTimeFilter}
            onChange={setToTimeFilter}
            options={generateTimeOptions("00:30", "24:00")}
            placeholder="To Time"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {toTimeFilter && <label htmlFor="toTimeFilter">To Time</label>}
        </div>

        {/* From Date Filter */}
        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${fromDateFilter ? "has-value" : ""}`}
            value={fromDateFilter}
            onChange={handleFromDateChange}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
            id="fromDateFilter"
          />
          {fromDateFilter && <label htmlFor="fromDateFilter">From Date</label>}
        </div>

        {/* To Date Filter */}
        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${toDateFilter ? "has-value" : ""}`}
            value={toDateFilter}
            onChange={handleToDateChange}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
            id="toDateFilter"
          />
          {toDateFilter && <label htmlFor="toDateFilter">To Date</label>}
        </div>
        <div className="floating-select" style={{maxWidth:'60px'}}>
          <button className="tt-action-btn" onClick={fetchUtilizationData}>
            <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          </button>
        </div>
      </div>
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {!loading && !error && data.length === 0 && (
        <div className="error-message">
          No Data Available
        </div>
      )}
      
      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              <th>Sport</th>
              <th>Coaching</th>
              <th>PlayO Booking</th>
              <th>Walk-in</th>
              <th>Membership</th>
              <th>Bulk Booking</th>
              <th>Maintenance Hours</th>
              <th>Total Hours</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                <td className="dur-bold-text">{row.sport}</td>
                <td>{row.coaching}</td>
                <td>{row.playOBooking}</td>
                <td>{row.walkIn}</td>
                <td>{row.membership}</td>
                <td>{row.bulkBooking}</td>
                <td>{row.maintenance}</td>
                <td className="dur-bold-text">{row.total}</td>
              </tr>
            ))}
            <tr className="dur-total-row">
              <td className="dur-bold-text">Total</td>
              <td className="dur-bold-text">{totals.coaching}</td>
              <td className="dur-bold-text">{totals.playOBooking}</td>
              <td className="dur-bold-text">{totals.walkIn}</td>
              <td className="dur-bold-text">{totals.membership}</td>
              <td className="dur-bold-text">{totals.bulkBooking}</td>
              <td className="dur-bold-text">{totals.maintenance}</td>
              <td className="dur-bold-green-text">{totals.total}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DailyUtilisationReport;
